function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.946,25.41v-9.158l9.3-4.92v9.158L14.946,25.41z M3.322,20.457v-9.092l8.303,4.921v9.124L3.322,20.457z M13.618,3.641 l8.569,4.855l-8.569,4.856L5.049,8.498L13.618,3.641z M26.37,6.964L14.481,0.22c-0.532-0.293-1.195-0.293-1.728,0L0.698,7.031h0.134 C0.267,7.324,0,7.911,0,8.562v12.873c0,0.617,0.166,1.174,0.73,1.467l12.089,6.908c0.267,0.162,0.532,0.227,0.83,0.227h0.034h0.033 c0.298,0,0.599-0.064,0.864-0.227l12.157-6.908c0.531-0.293,0.863-0.881,0.863-1.467L27.601,8.562 C27.566,7.813,27.069,7.194,26.37,6.964L26.37,6.964z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    version: 1.1,
    id: "Capa_1",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 27.602 30.037",
    enableBackground: "new 0 0 27.602 30.037",
    xmlSpace: "preserve"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/3d.7e3134c4.svg";
export { SvgComponent as ReactComponent };